<template>
	<div class="text-center">
		<v-dialog v-model="dialog" width="80%">
			<v-card>
				<v-card-title class="text-h5 bk-main lighten-2"> 依頼内容確認</v-card-title>
				<div class="pa-2">
					<table>
						<RequirementConfirmRecord
							:name="`依頼内容`"
							:value="requirement.requirement_type.name"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="false"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							:name="`サブタイトル`"
							:value="requirement.subtitle"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="false"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							:name="`依頼元部門`"
							:value="requirement.from_department.name"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="false"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							:name="`依頼先部門`"
							:value="requirement.to_department.name"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="false"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							:name="`依頼者`"
							:value="common.returnUserName(requirement.user)"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="false"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							:name="`希望納期`"
							:value="common.formatDate(requirement.deadline)"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="false"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							:name="`伝達事項`"
							:value="requirement.message"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							:column="{ data_type: '' }"
							:wrapFlag="true"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							v-if="requirement.requirement_type.need_matter_flag && requirement.matter_id"
							:name="`案件`"
							:value="common.returnMatterInfoWithOrderNumber(requirement.matter)"
							:column="{ data_type: '' }"
							:wrapFlag="true"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							v-if="
								requirement.requirement_type.need_matter_flag &&
								requirement.matter_product.id != null
							"
							:name="`見積製品`"
							:value="requirement.matter_product.name"
							:column="{ data_type: '' }"
							:wrapFlag="true"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							v-if="
								requirement.requirement_type.need_matter_flag &&
								requirement.ordered_product.id != null
							"
							:name="`受注製品(製番)`"
							:value="requirement.ordered_product.name"
							:column="{ data_type: '' }"
							:wrapFlag="true"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							v-if="
								requirement.requirement_type.need_matter_flag &&
								requirement.order_individual_info.id != null
							"
							:name="`受注製品(枝番)`"
							:value="requirement.order_individual_info.sub_number"
							:column="{ data_type: '' }"
							:wrapFlag="true"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmRecord
							v-for="value in requirementValuesWithoutFile"
							:key="value.id"
							:column="value.requirement_column"
							:name="value.requirement_column.name"
							:value="
								value.requirement_column.data_type == 'synchronization'
									? value.value
									: common.value(value.requirement_column, value.value)
							"
							:wrapFlag="value.requirement_column.data_type == 'text' ? true : false"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
						<RequirementConfirmFileRecord
							v-for="value in requirementValuesWithFile"
							:key="value.id"
							:column="value.requirement_column"
							:name="value.requirement_column.name"
							:value="value"
							:wrapFlag="value.requirement_column.data_type == 'text' ? true : false"
							:fullCheckFLag="requirement.requirement_type.full_check_flag"
							@childChecked="addCheckedCounter()"
							@childNotChecked="removeCheckedCounter()"
							@childAddMaxCounter="addMaxCounter()"
						/>
					</table>
				</div>
				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialog = false"> 戻る </v-btn>
					<v-btn
						color="primary"
						v-if="
							requirement.requirement_type.full_check_flag == false ||
							(requirement.requirement_type.full_check_flag == true && isDisableConfirmFlag)
						"
						text
						@click="changeStatusFromDraft()"
					>
						{{ common.setConfirmWord(requirement.requirement_type) }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<IndeterminateLoadingView :isLoading="isLoading" />
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import RequirementConfirmRecord from "./RequirementConfirmRecord.vue"
import RequirementConfirmFileRecord from "./RequirementConfirmFileRecord.vue"
import IndeterminateLoadingView from "../../shared/IndeterminateLoadingView.vue"
export default {
	components: {
		IndeterminateLoadingView,
		RequirementConfirmRecord,
		RequirementConfirmFileRecord,
	},
	props: {
		approvalFlag: Boolean,
		confirmationFlag: Boolean,
	},
	data() {
		return {
			isLoading: false,
			headers: [],
			dialog: false,
			common: common,
			checkedNumber: 0,
			checkMaxNumber: 0,
			isDisableConfirmFlag: false,
			requirement: {
				requirement_type: { name: "", full_check_flag: false },
				from_department: { name: "" },
				to_department: { name: "" },
				user: { last_name: "", first_name: "" },
			},
			requirementFixes: [],
			requirementValues: [],
			requirementId: "",
			requirementValuesWithoutFile: [],
			requirementValuesWithFile: [],
		}
	},
	mounted() {},
	watch: {
		checkedNumber() {
			if (this.checkedNumber == this.checkMaxNumber) {
				this.isDisableConfirmFlag = true
			} else {
				this.isDisableConfirmFlag = false
			}
		},
		requirementValues() {
			this.requirementValuesWithFile = []
			this.requirementValuesWithoutFile = []
			this.requirementValues.forEach((value) => {
				if (value.requirement_column.data_type == "file") {
					this.requirementValuesWithFile.push(value)
				} else {
					this.requirementValuesWithoutFile.push(value)
				}
			})
		},
	},
	methods: {
		changeStatusFromDraft() {
			const headers = authenticate.setHeader()
			axios
				.patch(
					"/erp/v1/requirements/status_id/" + this.requirement.id + ".json",
					{ requirement_id: this.requirement.id },
					{ headers }
				)
				.then((response) => {
					this.$store.dispatch("setFlash", {
						text: "状態を変更しました",
						type: "notice",
					})
					this.dialog = false
					this.requirement = response.data.requirement
					this.$emit("reloadShow", response.data.requirement, response.data.new_status_name)
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		openDialog(id) {
			this.requirementId = id
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/requirements/" + this.requirementId + ".json", { headers })
				.then((response) => {
					console.log(response.data)
					this.requirement = response.data.requirement
					this.requirementValues = response.data.requirement_values
					this.requirementFixes = response.data.requirement_fixes
					this.dialog = true
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		addCheckedCounter() {
			this.checkedNumber += 1
		},
		removeCheckedCounter() {
			this.checkedNumber -= 1
		},
		addMaxCounter() {
			this.checkMaxNumber += 1
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";
.bk-main {
	background-color: $main-color;
	color: white;
}
table {
	width: 100%;
}
</style>
